import fetchAPI from '../../../utils/fetchApi';
import { TProximityDealers } from 'types/TCarousels';

export default async function getFavorites(): Promise<TProximityDealers> {
  try {
    return await fetchAPI({
      url: `/cp/api/proximity-dealers`,
      method: 'GET',
    });
  } catch {
    return {
      type: '',
      items: [],
    };
  }
}
